module.exports = __webpack_public_path__ + "img/share_bg.5bd3143a.jpg";